import { ContentModel } from "../../../common/models/content.model";
import { MenuAppLinks } from "../menu.model";

export class DialogMenuData {
    pageContent: ContentModel[];
    appLinks: MenuAppLinks;
}